import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  DOLLY_URL,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'legendofdolly' })
export default class LegendOfDolly extends VuexModule {
  @Action
  FetchDollyReport() {
    return Vue.axios({
      url: DOLLY_URL,
      data: {},
      method: M_POST,
    })
      .then(({ data }) => {
        if (data.status.code === 0) {
          const item = data.data;
          return item;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
